import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Культурный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Форма активного отдыха, вид спортивного туризма.</p>
                    <p>Осуществляется в виде конных маршрутов, проходящих по заповедникам или национальным паркам.
                        Конный туризм пользуется популярностью у любителей экологического туризма, поскольку позволяет
                        туристам побывать в отдаленных от транспортных путей местах, обычно очень красивых, с
                        первозданной природой. Сложность разработки и реализации конного туризма заключается в
                        необходимости обеспечить особый уход за лошадьми, организовать стоянки и особые меры
                        безопасности и т.п.</p>
                </div>
            </div>
        </>
    );
}